import { all } from './search';

const topics = {
	search: {
		all,
	},
};

export default topics;
